define(['core/iterate'], function (iterate) {
        return {
            create: function (previewNodes, previewConfig, onSwitch) {

                let mainPageContent = document.querySelector(".nps-content");
                let npsSteps = document.querySelector(".nps-stepper");
                let hrElement = npsSteps ? npsSteps.nextElementSibling : '';

                previewNodes.closeButton.addEventListener("click", function (e) {
                    e.preventDefault();
                    closePreview();
                });

                parsePreview = (html) => {

                    var wrap = document.createElement("div");
                    wrap.innerHTML = html;
        
                    var body = wrap.querySelector(".application-body");
                    var data = body.getAttribute("data-json");
        
                    return {
                        html: body.innerHTML,
                        data: data ? JSON.parse(data) : {}
                    };
        
                }

                getContent = (step, callback) => {
                    previewNodes.content.classList.add("hide");
                    
                    let url = previewConfig.steps[step].url;
                    let requestBody = previewConfig.steps[step].requestBody || [];
                    let method = previewConfig.steps[step].method;

                    var xhr = new XMLHttpRequest();
                    xhr.open(method, url, true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    body = requestBody.join('&').replace(/%20/g, '+');
                    xhr.send(body);

                    xhr.onload = function () {

                        previewNodes.content.classList.remove("hide");

                        if (xhr.status === 200) {

                            var previewContentHTML = method === "POST" ? parsePreview(xhr.responseText).html : xhr.responseText;

                            if(previewNodes.continueButton) {
                                if (!previewContentHTML) {
                                    previewNodes.continueButton.style.display = "none";
                                } else {
                                    previewNodes.continueButton.style.display = "block";
                                    previewNodes.continueButton.href = previewConfig.nextPage;
                                }
                            }

                            previewNodes.closeButton.addEventListener("click", this.closePreview);

                            previewNodes.content.innerHTML = (
                                previewContentHTML ? previewContentHTML : `
                                    <p class='input-message active' style='text-align: center;'>Something went wrong</p>`);

                            if(previewConfig.steps[step].callback){
                                previewConfig.steps[step].callback();
                            }

                            if(callback){
                                callback();
                            }
                        }
                    }
                }

                let renderedSteps = previewConfig.steps.map((step, i) => {
                    /* accepts the following config:
                        [{
                            title: string,
                            url: string,
                            method: string
                            requestBody: array (optional)
                            callback: func (optional)
                        }]  
                    */
                    return `
                    <div class="title
                        ${i === 0 ? 'active' : ''}"
                        ${step.url ? "data-url=${step.url}" : ''}
                        >
                            ${step.title}
                    </div>`
                })

                previewNodes.steps.innerHTML = renderedSteps.join('');
                let stepTitles = previewNodes.steps.querySelectorAll(".title");

                setActiveTitle = (titleIndex) => {
                    previewNodes.steps.querySelector(".title.active").classList.remove("active");
                    stepTitles[titleIndex].classList.add("active");
                }

                stepTitles.forEach((title, index) => {
                    title.addEventListener("click", () => {
                        setActiveTitle(index)
                        getContent(index)
                    })
                })

                closePreview = () => {
                    previewNodes.wrapper.classList.remove("active");
                    if(mainPageContent){
                        mainPageContent.classList.remove("hide");
                    }
                    if(npsSteps) {
                        npsSteps.classList.remove("hide");
                        if(hrElement && hrElement.tagName === "HR") {
                            hrElement.classList.remove("hide");
                        }
                    }
                }

                open = (callback) => {
                    getContent(0, callback)
                    setActiveTitle(0)
                    previewNodes.wrapper.classList.add("active");
                    if(mainPageContent){
                        mainPageContent.classList.add("hide");
                    }
                    if(npsSteps) {
                        npsSteps.classList.add("hide");
                        if(hrElement && hrElement.tagName === "HR") {
                            hrElement.classList.add("hide");
                        }
                    }

                    previewNodes.steps.scrollIntoView({ behavior: "instant"})
                }

                return {
                    open: open,
                    close: closePreview
                }

            }
        }
    }
);
